import React, { useState, useEffect } from 'react';


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';


import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';
import ProjectCardLandscap from './projectCardLandscap';
import ProjectCardPortrait from './projectCardPortrait';





const FeaturedProjectCommercial = ({}) => {   

    
    // useEffect(() => {
	// 	loadData();
	// },[]);

    // const loadData = async() => {
    //     await getRelatedProperties({property_type_id: propertyTypeId, propertyType: propertyType, entity_id: entityId}).then(res => {
    //         // console.log()
    //     })
        
    // }

    
    
    
    return (
        <section className='pt-5 pb-5 featuredBox'>
                <Container>
                    <h3 className="text-center mb-4">Feature Project Commercial</h3>
                    <Row>
                        <Col xl={4}>
                            <ProjectCardLandscap />
                        </Col>
                        <Col xl={8}>
                            <Row>
                                <Col md={6}>
                                    <ProjectCardPortrait />
                                </Col>
                                <Col md={6}>
                                    <ProjectCardPortrait />
                                </Col>
                                <Col md={6}>
                                    <ProjectCardPortrait />
                                </Col>
                                <Col md={6}>
                                    <ProjectCardPortrait />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className='text-center'><Button href="#">See All Properties</Button></div>
                </Container>
            </section>
    )
}
function mapStateToProps(state) {
    return {
        relatedProperties: state.property.relatedProperties
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getRelatedProperties: (post) => dispatch(actions.getRelatedProperties(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(FeaturedProjectCommercial);